import { type FC, type ReactNode } from "react";

import { type SnippetEntity } from "./observabilityModel";

export const SnippetOverlay: FC<{
  snippet: SnippetEntity;
  onClose: () => void;
}> = ({ snippet, onClose }) => (
  <Overlay
    onClose={onClose}
    title={`Snippet ${snippet.sha.slice(0, 12)}…`}
    level={2}
  >
    <div className="flex items-center gap-3 border-b border-slate-100 px-4 py-2 font-mono text-[10px] uppercase tracking-widest text-slate-400 dark:border-slate-800">
      <span>{snippet.byteLength} bytes</span>
      <span>~{snippet.tokenEstimate ?? "?"} tokens</span>
      <span className="ml-auto text-slate-700 dark:text-slate-300">
        first seen {new Date(snippet.firstSeenAt).toLocaleString()}
      </span>
    </div>
    <pre className="whitespace-pre-wrap break-words px-4 py-3 font-mono text-[11px] text-slate-700 dark:text-slate-300">
      {snippet.content}
    </pre>
  </Overlay>
);

// ---------------------------------------------------------------------------
// Diff overlay — two-column composition diff.
// ---------------------------------------------------------------------------

export const Overlay: FC<{
  onClose: () => void;
  title: string;
  children: ReactNode;
  level?: 1 | 2;
}> = ({ onClose, title, children, level = 1 }) => (
  <div
    className={`absolute inset-0 flex flex-col overflow-x-hidden bg-white dark:bg-slate-950 ${level === 2 ? "z-20" : "z-10"}`}
  >
    <div className="flex items-center justify-between border-b border-slate-100 px-4 py-2 dark:border-slate-800">
      <span className="truncate font-mono text-[11px] uppercase tracking-widest text-slate-600 dark:text-slate-300">
        {title}
      </span>
      <button
        type="button"
        onClick={onClose}
        className="font-mono text-[10px] uppercase tracking-widest text-slate-400 transition-colors hover:text-slate-900 dark:hover:text-slate-100"
      >
        close ×
      </button>
    </div>
    <div className="flex-1 overflow-y-auto">{children}</div>
  </div>
);
